import OrganizationProfile from "../../../componentLayer/pages/settings/SettingsComponents/Organizationprofile/Oranizationprofiles";
export const organizationRouter = [
    
    { index:true, element: <OrganizationProfile /> },
]